import React, { useState } from "react";
import "../App.css";
import { Tabs } from "./Tabs";
import { Footer } from "./Footer";

export function Body({
  divisions,
  checkedDivisions,
  opts,
  setOpts,
  permissions,
  org,
  tabName,
  setTabName,
  filters,
  setIsVisible,
  exportStatus,
  onExportCsv,
  selectedExportRows,
  setSelectedExportRows,
}) {
  const [pageCount, setPageCount] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [activeTab, setActiveTab] = useState("");
  const handleClick = (event) => {
    setActiveTab(event.target.innerText);
  };

  // useEffect(() => {
  //   console.log("Active Tab :", activeTab)
  // }, [activeTab]);

  const onPageChange = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  return (
    <div className="body-workspace">
      <div className="body-workspace-content">
        <Tabs
          divisions={divisions}
          checkedDivisions={checkedDivisions}
          pageCount={pageCount}
          setPageCount={setPageCount}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          onPageChange={onPageChange}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          handleClick={handleClick}
          opts={opts}
          setOpts={setOpts}
          permissions={permissions}
          org={org}
          tabName={tabName}
          setTabName={setTabName}
          filters={filters}
          setIsVisible={setIsVisible}
          exportStatus={exportStatus}
          onExportCsv={onExportCsv}
          selectedExportRows={selectedExportRows}
          setSelectedExportRows={setSelectedExportRows}
        />
        <Footer
          pageCount={pageCount}
          pageNumber={pageNumber}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
}
